import { PlayScreen } from '@/screens/index'

export default function () {
  return <PlayScreen />
}
